import axios from 'axios'
import { Message } from 'element-ui'

export const apiUrl = 'https://api.freebeatfit.com/'
// export const apiUrl = 'https://staging-api.freebeatfit.com/'


const service = axios.create({
    baseURL: apiUrl,
    timeout: 100000,
    withCredentials: true
})

service.interceptors.request.use(config => {
    // 在发送请求之前做些什么
    // config.headers['appversion'] = 'ios_1.11.1';
    // config.headers['osversion'] = 'ios_14.5';
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

service.interceptors.response.use(
    response => {
        console.log(response);
        if (response.data.code != 200) {
            let msg = response.data.msg
            throw response.data.msg
        }
        return response
    },
    error => {
        Message.error(error.message)
        return Promise.reject(error)
    }
)
const get = (url, params) => {
    return service.request({
        url: url,
        method: "GET",
        params: params,
    })
}

const post = (url, params) => {
    return service.post(url, params)
}

export default { service, get, post }



// WEBPACK FOOTER //
// ./src/api/http.js